$.fn.reduce = [].reduce;

$(document).on('submit', '[data-menu-position-update-form]', (event) => {
  event.preventDefault();
});

const xhr = {};
const updateQueue = [];
let updatePromise = null;

function validateQuantity($input, updateRefDependencies = false) {
  let quantity = parseInt($input.val(), 10);
  if (Number.isNaN(quantity) || quantity <= 0) {
    quantity = 0;
  }
  if ($input.data('infoTo')) {
    clearTimeout($input.data('infoTo'));
    $input.data('infoTo', null);
  }
  const step = parseInt($input.attr('step'), 10);
  if (step > 1 && quantity % step > 0) {
    $input.siblings('.food-number__info').hide();
    $input.siblings('.food-number__info--step').show();
    $input.data('infoTo', setTimeout(() => $input.siblings('.food-number__info').hide(), 5000));
    return $input.get(0).defaultValue;
  }
  const maxQty = parseInt($input.attr('max'), 10);
  let fixed = false;
  if (maxQty && quantity > maxQty) {
    $input.siblings('.food-number__info').hide();
    $input.siblings('.food-number__info--max').show();
    $input.data('infoTo', setTimeout(() => $input.siblings('.food-number__info').hide(), 5000));
    quantity = maxQty;
    fixed = true;
  }
  const ref = $input.attr('data-menu-quantity-ref');
  if (ref) {
    const refQty = parseInt($(`input[data-menu-quantity="${ref}"]`).val(), 10) * 2;
    if (quantity > (refQty || 0)) {
      $input.siblings('.food-number__info').hide();
      $input.siblings('.food-number__info--ref').show().find('span').text(refQty || 0);
      $input.data('infoTo', setTimeout(() => $input.siblings('.food-number__info').hide(), 5000));
      return refQty || '';
    }
  } else if (updateRefDependencies) {
    const selfRef = $input.attr('data-menu-quantity');
    const refInput = $(`input[data-menu-quantity-ref="${selfRef}"]`);
    if (refInput.length) {
      refInput.val(quantity || '').trigger('change');
    }
  }

  if (!fixed) {
    $input.siblings('.food-number__info').hide();
  }
  return quantity || '';
}

$(document).on('click', '[data-cart-button]', function(event) {
  if ($(this).hasClass('light-gray')) {
    event.preventDefault();
  }
});

function processQueue() {
  if (!updateQueue.length) {
    return;
  }

  $('[data-cart-button]').addClass('light-gray').removeClass('secondary');
  $('[data-menu-total]').addClass('loader');
  const data = {};
  while (updateQueue.length) {
    const entry = updateQueue.shift();
    data[`quantity_${entry.number}`] = entry.quantity;
    data[`uom_${entry.number}`] = entry.uom;
  }

  updatePromise = $.ajax({
    url: $('[data-menu-position-update-url]').attr('data-menu-position-update-url'),
    method: 'POST',
    data,
  }).then((response) => {
    $('[data-menu-total]').removeClass('loader');
    $('[data-cart-button]').removeClass('light-gray').addClass('secondary');
    updatePromise = null;
    processQueue();

    if (response.status) {
      $('[data-menu-total-amount]').html(response.orderHeader.grand_total);
    }
  });
}

function updatePositionQuantity(input, quantity) {
  if (quantity === (parseInt(input.defaultValue, 10) || '')) {
    return;
  }
  const $input = $(input);
  const uom = $input.attr('data-menu-quantity-uom');
  const number = $input.attr('data-menu-quantity');
  input.defaultValue = `${quantity}`;
  $input.val(input.defaultValue);

  updateQueue.push({
    number,
    quantity: quantity || 0,
    uom,
  });

  if (!updatePromise) {
    processQueue();
  }

  const day = $input.closest('[data-menu-day]');
  const quantities = day.find('[data-menu-quantity]');
  const totalQuantity = quantities.reduce(
    (acc, current) => acc + Math.max(parseInt($(current).val(), 10) || 0, 0),
    0,
  );
  day.find('[data-menu-day-total-quantity]').html(totalQuantity);

  const mainGroupTabContent = $input.closest('.tabs-panel');
  const mainGroupQuantities = mainGroupTabContent.find('[data-menu-quantity]');
  const mainGroupTotalQuantity = mainGroupQuantities.reduce(
    (acc, current) => acc + Math.max(parseInt($(current).val(), 10) || 0, 0),
    0,
  );
  const mainGroupTab = $(`.shopsubheader__link[href="#${mainGroupTabContent.attr('id')}"]`);
  mainGroupTab.find('[data-menu-week-total-quantity]').html(mainGroupTotalQuantity);
}

$(document).on('keydown', '[data-menu-number-of-persons-update-url], [data-menu-quantity]', function(event) {
  if (event.which === 38 || event.which === 40) {
    // disable up/down keys
    event.preventDefault();
  } else if (event.which === 13) {
    // emulate tab
    event.stopPropagation();
    event.preventDefault();
    const $inputs = $('input:visible:not(:disabled)');
    const index = $inputs.index(this);
    let target;
    if (index === $inputs.length - 1) {
      target = $inputs.get(0);
    } else {
      target = $inputs.get(index + 1);
    }
    target.focus();
    if (target.scrollIntoViewIfNeeded) {
      target.scrollIntoViewIfNeeded();
    }
  }
});

$(document).on('input', '[data-menu-number-of-persons-update-url]', window.Foundation.util.debounce(
  function() {
    const url = $(this).attr('data-menu-number-of-persons-update-url');
    const numberOfPersons = parseInt($(this).val(), 10) || 0;
    $(`input[data-menu-number-of-persons-update-url="${url}"]`).val(numberOfPersons || '');
    xhr[url] = $.ajax({
      url,
      method: 'POST',
      data: { number_of_persons: numberOfPersons },
    });
  },
  250,
));

$(document).on('change', '[data-menu-quantity][data-menu-position-update-url]', function() {
  const qty = validateQuantity($(this), true);
  updatePositionQuantity(this, qty);
  $(this).val(qty);
  if ($(this).val() !== '') {
    $(this).addClass('input-green');
  } else {
    $(this).removeClass('input-green');
  }
});

$(document).on('change', '[data-menu-quantity]:not([data-menu-position-update-url])', function() {
  $(this).val(validateQuantity($(this)) || '');
  if ($(this).val() === this.defaultValue) {
    return;
  }
  $(this).val($(this).val() || 0);
  if (parseInt($(this).val(), 10) === 0) {
    const $hidden = $(`input[type="hidden"][name="${this.name}"]`);
    if ($hidden.length) {
      $hidden.closest('form').submit();
      return;
    }
  }
  $(this).closest('form').submit();
});

$(document).on('input', '[data-menu-quantity]', function () {
  if ($(this).val() !== '') {
    $(this).addClass('input-green');
  } else {
    $(this).removeClass('input-green');
  }
});

$(document).on('click', '[data-ingredients]', function() {
  $.ajax({
    url: $(this).attr('data-ingredients'),
    success: (response) => {
      $(response).foundation().foundation('open');
    },
  });
});

$(document).on('click', '[data-info-hide]', function() {
  const id = $(this).attr('data-info-hide');
  const flags = document.location.protocol === 'https:' ? 'SameSite=None;Secure' : '';
  document.cookie = `closed_info_layer_${id}=${id};expires=Fri, 30 Dec 9999 23:59:59 GMT;path=/;${flags}`;
});
